
/* WMG product-page helpers. The options app renders late, so we poll. */
(function(){
  var TERMS='/pages/bot-3000e-rental-terms';
  var NOTE='Look for the number that starts with <strong>VS</strong> or <strong>SN</strong> on the instrument label; the format changed over the years. The <strong>last four digits</strong> are all we need.';
  function path(){ return window.location.pathname; }
  function form(){ return document.querySelector('form[action*="/cart/add"]'); }

  function shortenTerms(){
    if(path().indexOf('bot-3000e-tribometer-rental')<0 && path().indexOf('rent-a-pendulum')<0) return;
    var changed=false;
    var all=document.querySelectorAll('div,span,p,label');
    Array.prototype.forEach.call(all,function(el){
      if(el.getAttribute('data-wmg-tc')) return;
      if(el.children.length>0) return;
      var t=(el.textContent||'').trim();
      if(t.length>400 && /TERMS\s*&?\s*CONDITIONS|Equipment Rented|rental of the tribometer/i.test(t)){
        el.setAttribute('data-wmg-tc','1');
        el.innerHTML='<span class="wmg-tc-link">Please <a class="wmg-terms-link" href="'+TERMS+'" target="_blank" rel="noopener">read the full rental terms and conditions</a> before you book. Ticking the boxes below confirms you accept them.</span>';
        changed=true;
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('label,span'),function(el){
      if(el.getAttribute('data-wmg-tcl')) return;
      if(el.children.length>0) return;
      var t=(el.textContent||'').trim();
      if(t.length>80 && t.length<=400 && /terms\s*&?\s*conditions/i.test(t)){
        el.setAttribute('data-wmg-tcl','1');
        el.innerHTML='I have read and accept the <a class="wmg-terms-link" href="'+TERMS+'" target="_blank" rel="noopener">rental terms and conditions</a>.';
        changed=true;
      }
    });
    return changed;
  }

  function serialBits(){
    var f=form(); if(!f) return false;
    var isTrouble = path().indexOf('bot-3000e-troubleshooting')>=0;
    var isCal     = path().indexOf('annual-calibration-service')>=0;
    if(!isTrouble && !isCal) return false;
    var input=document.querySelector('input[name="properties[Serial Number]"]');
    if(isTrouble && !input){
      var wrap=document.createElement('div');
      wrap.className='wmg-serial';
      wrap.innerHTML='<label for="wmg-serial-input">Serial Number * (Required)</label>'+
        '<input id="wmg-serial-input" type="text" name="properties[Serial Number]" required>';
      var anchor=f.querySelector('.product-form__buttons') || f.querySelector('button[type=submit]');
      if(anchor && anchor.parentNode){ anchor.parentNode.insertBefore(wrap,anchor); } else { f.appendChild(wrap); }
      input=wrap.querySelector('input');
    }
    if(input && !document.querySelector('.wmg-serial-note')){
      var n=document.createElement('p');
      n.className='wmg-serial-note'; n.innerHTML=NOTE;
      input.parentNode.insertBefore(n, input);
      return true;
    }
    return false;
  }

  function run(){ try{ shortenTerms(); serialBits(); }catch(e){} }

  function start(){
    run();
    var t0=Date.now();
    var iv=setInterval(function(){ run(); if(Date.now()-t0>25000) clearInterval(iv); }, 600);
    try{ new MutationObserver(function(){ run(); }).observe(document.body,{childList:true,subtree:true}); }catch(e){}
  }
  if(document.readyState!=='loading'){ start(); } else { document.addEventListener('DOMContentLoaded', start); }
})();

/* keep every tile label on one line: shrink to fit rather than clip */
(function(){
  function fitLabels(){ return; }
function fitLabelsOld(){
    var els=document.querySelectorAll('.wmg-sub__t');
    Array.prototype.forEach.call(els,function(el){
      if(el.getAttribute('data-fit')) return;
      var size=12;
      el.style.fontSize=size+'px';
      var guard=0;
      while(el.scrollWidth>el.clientWidth+1 && size>9 && guard<12){ size-=0.5; el.style.fontSize=size+'px'; guard++; }
      el.setAttribute('data-fit','1');
    });
  }
  function boot(){ fitLabels(); setTimeout(fitLabels,700); setTimeout(fitLabels,2000);
    window.addEventListener('resize',function(){
      Array.prototype.forEach.call(document.querySelectorAll('.wmg-sub__t'),function(e){ e.removeAttribute('data-fit'); });
      fitLabels(); });
  }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();

/* WMG shipping insurance opt-in.
   The checkbox is rendered by buy-buttons.liquid on heavy and rental products.
   Buy it now is suppressed on those products, so every buyer passes here. */
(function(){
  var BUSY = false;
  function box(form){
    var root = form.closest('.product-form__buttons') ? form : form;
    return document.querySelector('.wmg-ins__box');
  }
  document.addEventListener('submit', function(ev){
    var form = ev.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var cb = box(form);
    if (!cb || !cb.checked || BUSY) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    BUSY = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: parseInt(cb.getAttribute('data-wmg-ins-variant'), 10),
        quantity: parseInt(cb.getAttribute('data-wmg-ins-qty'), 10) || 1
      })
    }).catch(function(){}).then(function(){
      cb.checked = false;
      if (form.requestSubmit) { form.requestSubmit(); } else { form.submit(); }
      setTimeout(function(){ BUSY = false; }, 1200);
    });
  }, true);
})();

/* wmg-notif-guard
   Dawn's add-to-cart popup carries its own Check out form, which skips the cart
   page. When the cart holds an instrument or a rental and no insurance line, hide
   that form and promote View cart instead.

   The popup re-renders its own sections after every add, so inline styles get
   wiped. State lives as a class on <html>, which survives, and the styling and
   the notice are done in CSS. This JS only decides true or false. */
(function(){
  var INSURANCE_PRODUCT = 8989226533107;
  var HEAVY_GRAMS = 13000;            /* 30 lb, the heavy profile threshold */
  var HOLD_CLASS = 'wmg-hold-checkout';
  var held = false;

  function decide(cart){
    var heavy = false, insured = false;
    (cart.items || []).forEach(function(i){
      if (i.requires_shipping && i.grams >= HEAVY_GRAMS) heavy = true;
      if (i.product_id === INSURANCE_PRODUCT) insured = true;
    });
    held = heavy && !insured;
    document.documentElement.classList.toggle(HOLD_CLASS, held);
  }

  var pending = null;
  function refresh(){
    clearTimeout(pending);
    pending = setTimeout(function(){
      fetch('/cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(decide)
        .catch(function(){});
    }, 80);
  }

  /* Safety net: even if the CSS were bypassed, do not let the popup's
     Check out submit through while the cart is held. */
  document.addEventListener('submit', function(ev){
    var f = ev.target;
    if (!held || !f || f.id !== 'cart-notification-form') return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    window.location.href = '/cart';
  }, true);

  function watch(){
    var n = document.getElementById('cart-notification');
    if (!n) return false;
    new MutationObserver(refresh).observe(n, {attributes:true, childList:true, subtree:true});
    refresh();
    return true;
  }

  /* Every cart mutation on this theme goes through fetch, Dawn's own adds
     included, so re-evaluate after any of them rather than guessing at events. */
  var nativeFetch = window.fetch.bind(window);
  window.fetch = function(){
    var url = '';
    try { url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || ''; } catch (e) {}
    var p = nativeFetch.apply(null, arguments);
    if (url.indexOf('/cart/') !== -1 && url.indexOf('/cart/shipping_rates') === -1) {
      p.then(function(){ refresh(); }).catch(function(){});
    }
    return p;
  };

  if (!watch()){
    var tries = 0;
    var t = setInterval(function(){ if (watch() || ++tries > 50) clearInterval(t); }, 500);
  }
})();

/* wmg-collections-root
   The main site's To Store link points at /collections, which lands visitors on
   the bare collection index instead of the storefront home page. Shopify URL
   redirects only fire on 404s and this route is valid, so it is handled here.
   Runs from <head>, before the body paints. */
(function(){
  try{
    var p = window.location.pathname.replace(/\/+$/, '');
    if (p === '/collections') {
      window.location.replace('/' + window.location.search + window.location.hash);
    }
  }catch(e){}
})();

/* WMG course fields v2 */
(function(){
var BOT="online-bot-3000e-training-course";
var UNT="unt-course";
function p(){return window.location.pathname}
function which(){if(p().indexOf(BOT)>=0)return "BOT";if(p().indexOf(UNT)>=0)return "UNT";return null}
function form(){var l=document.querySelectorAll('form[action*="/cart/add"]');for(var i=0;i<l.length;i++){if(l[i].querySelector(".product-form__buttons"))return l[i]}return null}
function qty(){var q=document.querySelector('input[name="quantity"]');var n=parseInt(q&&q.value,10);return n>0?Math.min(n,20):1}
function fld(id,slot,prop,label,type,ph){
 return '<div class="wmg-cf"><label class="wmg-cf__label" for="'+id+'">'+label+' <span class="wmg-cf__req">(required)</span></label>'
 +'<input class="wmg-cf__input" id="'+id+'" data-slot="'+slot+'" type="'+type+'" autocomplete="off" placeholder="'+ph+'" name="properties['+prop+']" required></div>';
}
function build(){
 var w=which();if(!w)return;
 var f=form();if(!f)return;
 var anchor=f.querySelector(".product-form__buttons");if(!anchor)return;
 var n=qty();
 var old=document.querySelector(".wmg-attendee");
 if(old&&old.getAttribute("data-qty")===String(n)&&f.contains(old))return;
 var keep={};
 if(old){Array.prototype.forEach.call(old.querySelectorAll("input"),function(i){keep[i.getAttribute("data-slot")]=i.value});old.parentNode.removeChild(old)}
 var box=document.createElement("div");
 box.className="wmg-serial wmg-attendee";box.setAttribute("data-qty",String(n));
 var h='<p class="wmg-serial-note">We email the course details straight to the person taking it. Please give the name and email exactly as they should appear on the <strong>certificate</strong>.</p>';
 for(var i=1;i<=n;i++){
  var sfx=n>1?" "+i:"";
  if(n>1)h+='<p class="wmg-attendee__seat">Seat '+i+'</p>';
  h+=fld("wmg-att-n-"+i,"n"+i,"Attendee"+sfx+" Name","Name of the person taking the course","text","First and last name");
  h+=fld("wmg-att-e-"+i,"e"+i,"Attendee"+sfx+" Email","Email address for that person","email","name@company.com");
 }
 box.innerHTML=h;
 anchor.parentNode.insertBefore(box,anchor);
 Array.prototype.forEach.call(box.querySelectorAll("input"),function(i){var k=i.getAttribute("data-slot");if(keep[k])i.value=keep[k]});
}
function choice(){
 var vs=document.querySelector("variant-selects,variant-radios");
 if(!vs)return "";
 var r=vs.querySelector('input[type="radio"]:checked');
 if(r)return r.value||"";
 var s=vs.querySelector("select");
 if(s){var o=s.options[s.selectedIndex];return (o&&(o.value||o.text))||""}
 return "";
}
function recert(){
 if(which()!=="UNT")return;
 var isRe=/renewal|recert|certificate holder/i.test(choice());
 var note=document.querySelector(".wmg-recert");
 if(!isRe){if(note&&note.parentNode)note.parentNode.removeChild(note);return}
 var price=document.querySelector('[id^="price-template"]');
 if(!price)return;
 if(note){if(note.previousElementSibling===price)return;note.parentNode.removeChild(note)}
 var d=document.createElement("p");
 d.className="wmg-recert";
 d.innerHTML='<strong>Renewal price.</strong> We may ask you to provide a copy of your current UNT Walkway Safety certificate as proof before your course code is issued.';
 price.parentNode.insertBefore(d,price.nextSibling);
}
function tick(){build();recert()}
function start(){
 if(!which())return;
 tick();
 var t0=Date.now(),iv=setInterval(function(){tick();if(Date.now()-t0>25000)clearInterval(iv)},600);
 document.addEventListener("change",function(e){if(e.target&&(e.target.name==="quantity"||e.target.type==="radio"||e.target.tagName==="SELECT"))tick()},true);
 document.addEventListener("input",function(e){if(e.target&&e.target.name==="quantity")tick()},true);
 try{new MutationObserver(function(){tick()}).observe(document.body,{childList:true,subtree:true})}catch(e){}
}
if(document.readyState!=="loading")start();else document.addEventListener("DOMContentLoaded",start);
})();
